const removeTargetAttributeForHashAnchorTags = (parentElement: HTMLElement | null) => {
  if (parentElement) {
    const aTags = parentElement.getElementsByTagName('a')
    for (const aTag of aTags) {
      if (aTag.getAttribute('href')?.startsWith('#')) {
        aTag.removeAttribute('target')
      }
    }
  }
}

export default removeTargetAttributeForHashAnchorTags
